// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `li.active > a {
    background: var(--theme-background) !important;
    box-shadow: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/sidebar/sidebar.component.css"],"names":[],"mappings":"AAAA;IACI,8CAA8C;IAC9C,2BAA2B;AAC/B","sourcesContent":["li.active > a {\n    background: var(--theme-background) !important;\n    box-shadow: none !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
